// app/client.tsx
// trigger preview deploy: ENGG-265 (prac-portal preview needed for discount checkout E2E verification)
// trigger preview deploy: ENG-4972 Persist the conditions consent acknowledgment to the database
// trigger preview deploy: ENGG-555
// trigger preview deploy: ENGG-590
// trigger preview deploy: ENG-5046
import { StartClient } from '@tanstack/react-start/client';
import { hydrateRoot } from 'react-dom/client';
// import { registerSW } from 'virtual:pwa-register';
import 'react-toastify/dist/ReactToastify.css';
import '~/assets/global.css';
import { router } from './router';

// triggering practitioner-portal build

console.log('🚀 Client.tsx is executing...');

hydrateRoot(document, <StartClient router={router} />);

console.log('✅ React hydration complete');

export default null;

// const updateSW = registerSW({
//   // eslint-disable-next-line @typescript-eslint/no-explicit-any
//   onRegistered(r: any) {
//     r &&
//       setInterval(
//         () => {
//           r.update();
//         },
//         1000 * 60 * 60,
//       ); // 1 hour
//   },
//   onNeedRefresh() {
//     toast.dismiss();
//     toast(
//       <div>
//         <Typography variant='body-s'>
//           This page has been updated. Reload to see the latest version.
//         </Typography>
//         <div className='flex gap-3'>
//           <Button
//             label='Reload'
//             onClick={async () => {
//               await updateSW();
//               await toast.dismiss();
//             }}
//           />
//         </div>
//       </div>,
//       {
//         autoClose: false,
//         closeButton: false,
//       },
//     );
//   },
// });
// Manual service worker registration for cache-busting hotfix
// This forces cleanup of old service worker caches that are causing cache poisoning
console.log('Starting manual SW registration process...');

if ('serviceWorker' in navigator) {
  console.log('ServiceWorker supported, checking document ready state...');

  const runServiceWorkerSetup = async () => {
    console.log('🔧 Starting SW cleanup and registration...');
    try {
      // First, unregister any existing service workers to force cleanup
      console.log('🔧 Getting existing service worker registrations...');
      try {
        const registrations = await navigator.serviceWorker.getRegistrations();
        console.log('🔧 Found', registrations.length, 'existing registrations');
        console.log('🔧 Registrations array:', registrations);

        if (registrations && registrations.length > 0) {
          for (const registration of registrations) {
            console.log(
              '🔧 Unregistering old service worker:',
              registration.scope,
            );
            const unregistered = await registration.unregister();
            console.log('🔧 Unregistration result:', unregistered);
          }
        } else {
          console.log('🔧 No existing registrations to clean up');
        }
      } catch (error) {
        console.error('🔧 Error getting/unregistering service workers:', error);
      }

      // Clear all caches to force fresh start
      console.log('🔧 Checking for existing caches...');
      if ('caches' in window) {
        const cacheNames = await caches.keys();
        console.log(
          '🔧 Found',
          cacheNames.length,
          'existing caches:',
          cacheNames,
        );

        for (const cacheName of cacheNames) {
          console.log('🔧 Deleting cache:', cacheName);
          const deleted = await caches.delete(cacheName);
          console.log('🔧 Cache deletion result:', deleted);
        }
      } else {
        console.log('🔧 Caches API not available');
      }

      // Register new custom service worker (bypassing VitePWA completely)
      const registration = await navigator.serviceWorker.register('/sw.js', {
        scope: '/',
        updateViaCache: 'none', // Always check for updates
      });
      console.log('🔧 Custom SW registered successfully:', registration.scope);

      // Force immediate activation
      if (registration.waiting) {
        registration.waiting.postMessage({ type: 'SKIP_WAITING' });
      }

      // Listen for updates
      registration.addEventListener('updatefound', () => {
        const newWorker = registration.installing;
        if (newWorker) {
          newWorker.addEventListener('statechange', () => {
            if (
              newWorker.state === 'installed' &&
              navigator.serviceWorker.controller
            ) {
              console.log('🔧 New SW available and installed successfully');
            }
          });
        }
      });
    } catch (error) {
      console.log('SW registration failed:', error);
    }
  };

  // Run immediately if document is already loaded, otherwise wait for load event
  if (
    document.readyState === 'complete' ||
    document.readyState === 'interactive'
  ) {
    console.log('🔧 Document already loaded, running SW setup immediately...');
    runServiceWorkerSetup();
  } else {
    console.log('🔧 Document not ready, waiting for load event...');
    window.addEventListener('load', runServiceWorkerSetup);
  }
}
